import { fromJS } from 'immutable';
import { SHOW_BANNER } from 'reporting-data/constants/deprecate/deprecationTypes';
import { SHOW_DEAL_SPLIT_DEPRECATION_BANNER } from 'reporting-data/constants/gates';
import { DEAL_SPLIT } from '../../relational/metadata/objectTypes';
import { resolveReportMeta } from '../../relational/metadata/report-meta';
import { RelationalReport as RelationalReportRecord } from '../../relational/schema/report-records';
const DEAL_SPLIT_PROPERTIES = ['hs_all_deal_split_owner_ids', 'hs_num_associated_deal_splits'];
export const shouldDeprecate = (tableNamesToProperties, tables) => {
  const hasDealSplitTable = tables.some(table => {
    return table.get('dataSourceId', undefined) === DEAL_SPLIT || table.get('objectTypeId', undefined) === DEAL_SPLIT;
  });
  if (hasDealSplitTable) {
    return true;
  }
  const hasDealSplitProperties = tableNamesToProperties.some(properties => {
    return properties.some(property => {
      return DEAL_SPLIT_PROPERTIES.includes(property.get('name'));
    });
  });
  return hasDealSplitProperties;
};
export const singleDealSplitDeprecation = (report, userInfo) => {
  var _userInfo$gates;
  // Use direct access instead of getReportDefinition getter due to type incompatibility
  // with RelationalReportRecord constructor. This follows the pattern used in other migrations.
  const reportDefinition = report.get('reportDefinition');
  if (!(userInfo !== null && userInfo !== void 0 && (_userInfo$gates = userInfo.gates) !== null && _userInfo$gates !== void 0 && _userInfo$gates.includes(SHOW_DEAL_SPLIT_DEPRECATION_BANNER)) || !reportDefinition) {
    return Promise.resolve(report);
  }
  const reportDefinitionRecord = RelationalReportRecord(reportDefinition);
  return resolveReportMeta(reportDefinitionRecord).then(({
    properties,
    tables
  }) => {
    return shouldDeprecate(properties, tables) ? report.set('deprecation', fromJS({
      isDeprecated: true,
      type: SHOW_BANNER,
      message: 'dealSplitObjectChanged'
    })) : report;
  }).catch(() => {
    return report;
  });
};